
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import AOS from 'aos';

const CookiesPolicy = () => {
  const routes = all_routes;

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="main-wrapper">
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Politica de Cookies</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={routes.home}>Acasă</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Politica Cookies</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <section className="section-modern" style={{ padding: '60px 0' }}>
        <div className="container">
          <div 
            className="policy-content" 
            style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}
            data-aos="fade-up"
          >
             <h3 className="mb-3">1. Ce sunt cookie-urile?</h3>
             <p className="mb-4">
               Cookie-urile sunt fișiere de text de mici dimensiuni, formate din litere și numere, care sunt stocate pe computerul, terminalul mobil sau alte echipamente ale unui utilizator de pe care se accesează internetul.
             </p>

             <h3 className="mb-3">2. Ce tipuri de cookie-uri folosim?</h3>
             
             <h5 className="mt-3">a. Cookie-uri strict necesare (Esențiale)</h5>
             <p>
                Acestea sunt necesare pentru funcționarea site-ului și nu pot fi dezactivate în sistemele noastre. De exemplu, cookie-uri care rețin sesiunea de logare sau preferințele de confidențialitate.
             </p>

             <h5 className="mt-3">b. Cookie-uri de Analiză și Performanță</h5>
             <p>
                Ne permit să numărăm vizitele și sursele de trafic, pentru a putea măsura și îmbunătăți performanța site-ului nostru. Folosim servicii precum (ex: Google Analytics) pentru a înțelege cum interacționează vizitatorii cu site-ul. Datele sunt agregate și anonime.
             </p>

             <h5 className="mt-3">c. Cookie-uri de Marketing (Opționale)</h5>
             <p>
                Pot fi setate prin site-ul nostru de către partenerii noștri de publicitate (ex: Facebook Pixel, Google Ads). Acestea pot fi folosite pentru a vă crea un profil de interese și a vă afișa reclame relevante pe alte site-uri.
             </p>

             <h3 className="mb-3 mt-4">3. Cum puteți controla cookie-urile?</h3>
             <p>
               Puteți gestiona preferințele privind cookie-urile direct din setările browserului dumneavoastră. Iată link-uri utile pentru cele mai populare browsere:
             </p>
             <ul>
                 <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Google Chrome</a></li>
                 <li><a href="https://support.mozilla.org/ro/kb/activarea-si-dezactivarea-cookie-urilor" target="_blank" rel="noreferrer">Mozilla Firefox</a></li>
                 <li><a href="https://support.apple.com/ro-ro/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">Safari</a></li>
             </ul>
             <p>
                Refuzarea cookie-urilor poate degrada experiența de utilizare a site-ului.
             </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiesPolicy;
